import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import { generateColorGradient } from "../../../../Components/Hooks/useColorArrayHooks";
import BarBasicChart from "../../../../Components/Common/Charts/BarBasicChart";




const categoriesChart = ['Real','Autorizada','Proyectada',]
const colorsChart = generateColorGradient(3);


const BiomassInfo = ({ title, height, um = '' }) => {


    const [isSuccess, setIsSuccess] = useState(true);

    const seriesChart = [
        {
            name: "Real",
            data: [46,23,23,23],
        },
        {
            name: "Autorizada",
            data: [74,34,34,34],
        },
        {
            name: "Proyectada",
            data: [90,34,43],
        },
    ];
    
    const categoriesChart = [,'Ene','Feb','Mar','Abr']



    // const dispatch = useDispatch();

    // const selector = createSelector(
    //     state => state.ResidueDashboard,
    //     result => ({
    //         data: result.infoCategoryByYear,
    //         isLoading: result.isLoading,
    //         isSuccess: result.isSuccess,
    //         isError: result.isError,
    //     })
    // );

    // const { data, isLoading, isSuccess, isError } = useSelector(selector);

    // useEffect(() => {
    //     dispatch(getCategoryByYear());
    // }, []);

    // const { seriesChart, categoriesChart, yearTotals, difference } = prepareChartData(data);
    // const lengthChart = data?.detail?.length || 0;
    // const colorsChart = generateColorGradient(lengthChart);

    // if (isLoading) {
    //     return <OPlaceholder />;
    // }

    // if (isError) {
    //     return <CardWithError title={title} />;
    // }

    if (isSuccess) {
        return (
            <React.Fragment>
                <Card className='card-height-100'>
                    <CardHeader className='p-2 align-items-center d-flex'>
                        <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
                <div className='btn-box-dashboard'>
                            <Button color="secondary" size="sm" className="btn-soft-secondary me-1">
                                Todo
                            </Button>
                            <Button color="primary" size="sm" className="btn-soft-primary me-1">
                                1A
                            </Button>
                            <Button color="secondary" size="sm" className="btn-soft-secondary">
                                1M
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0 pb-2">
                        <div className="w-100">
                            <div dir="ltr">
                                <BarBasicChart
                                    seriesChart={seriesChart}
                                    categoriesChart={categoriesChart}
                                    colorsChart={colorsChart}
                                    height={height}
                                />
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }

    return <CardWithoutData title={title} />;

};

export default BiomassInfo;
